export default __webpack_public_path__ + "static/media/magnifying-glass-icon.a61480ac.png";